import React, { useEffect } from 'react'
import { useRouteMatch, match } from 'react-router-dom'

import { Alert, PortalPage, Stack } from 'component-library-next'

import { usePrintViewData } from '@app/modules/PrintView/usePrintViewData'
import { NavBar } from '@app/NavBar'

import { AppointmentsTable } from './Components/AppointmentsTable/AppointmentsTable'
import { ContactDetails } from './Components/ContactDetails/ContactDetails'
import { MessagesList } from './Components/MessagesList/MessagesList'
import './PrintViewPage.scss'

export const PrintViewPage = () => {
  const match: match<{ id: string }> = useRouteMatch()
  const customerId = Number(match.params.id)

  const { loading, error, contactDetails, messagesForList, appointments } = usePrintViewData({
    customerId
  })

  useEffect(() => {
    if (!loading && !error) {
      window.print()
    }
  }, [loading, error])

  if (error) {
    return (
      <Alert color={Alert.colors.warning}>
        Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
      </Alert>
    )
  }

  return (
    <>
      <NavBar title='Mandanten'>
        <PortalPage hideFooter>
          <Stack>
            <ContactDetails contactDetails={contactDetails} />
            <AppointmentsTable appointments={appointments} />
            <MessagesList messages={messagesForList} />
          </Stack>
        </PortalPage>
      </NavBar>
    </>
  )
}
